import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';
import { UserUpdate } from '../interfaces/userUpdate';

export const usersService = {
  getUser: () => axiosService.get(AXIOS_URLS.users).then((res) => res.data),
  updateUser: (user: UserUpdate) =>
    axiosService.put(AXIOS_URLS.users, user).then((res) => res.data),
};
